export const GENDER = [
  { key: 1, value: 'male', text: 'Male' },
  { key: 2, value: 'female', text: 'Female' },
  { key: 3, value: 'unknown', text: 'Unknown' },
  { key: 4, value: 'non-binary', text: 'Non-Binary'}
];
